module.exports = __webpack_public_path__ + "assets/img/赞赏@3x.15c844c5.png";